import { api, API } from "@/lib/api";

export const mediaUrl = (path, download) => (path ? `${API}/mk-media/${path}${download ? "?download=1" : ""}` : "");

export async function uploadMedia(file, kind, onProgress) {
  const { data: s } = await api.post("/admin/marketing/media/start", { kind, filename: file.name, size: file.size });
  for (let i = 0; i < s.chunks; i++) {
    const part = file.slice(i * s.chunk_size, (i + 1) * s.chunk_size);
    let ok = false;
    for (let attempt = 0; attempt < 3 && !ok; attempt++) {
      try {
        await api.put(`/admin/marketing/media/${s.id}/chunk/${i}`, part, { headers: { "Content-Type": "application/octet-stream" } });
        ok = true;
      } catch (e) {
        if (attempt === 2) throw e;
      }
    }
    onProgress?.(Math.round(((i + 1) / s.chunks) * 100));
  }
  const { data } = await api.post(`/admin/marketing/media/${s.id}/finish`);
  return data;
}

export async function waitJob(jobId, tries = 100) {
  for (let k = 0; k < tries; k++) {
    await new Promise((r) => setTimeout(r, 3000));
    const { data } = await api.get(`/admin/marketing/jobs/${jobId}`);
    if (data.status !== "running") return data;
  }
  throw new Error("Taking too long — please try again");
}

export const REEL_KEYS = ["source", "image_path", "video_id", "music_id", "music_start", "music_end", "music_volume", "keep_original", "original_volume", "duration"];
export const reelKey = (reel, imagePath) => JSON.stringify(REEL_KEYS.map((k) => (k === "image_path" ? (reel.source === "photo" ? imagePath : "") : reel[k] ?? "")));

export const fmtSec = (s) => {
  const v = Math.max(0, Number(s) || 0);
  return `${Math.floor(v / 60)}:${String(Math.floor(v % 60)).padStart(2, "0")}`;
};
